import cn from 'classnames'

import { useDropdown } from '@hooks/useDropdown'
import { SearchIcon } from '@components/icons/SearchIcon'
import { PenNameSearchSelectProps } from './interface'

export function PenNameSearchSelect({
  penNameSearchList,
  searchText,
  onSearch,
  handleSearchChange,
  handleSelectChange,
}: PenNameSearchSelectProps) {
  const { dropdownRef, isShowDropdown, toggleDropdown } = useDropdown()
  return (
    <div ref={dropdownRef} className='relative'>
      <div
        className={cn(
          'flex items-center w-full mobile:w-full h-[40px] border border-gray-4 dark:border-purple bg-gray-4 dark:bg-dark-8 rounded-[20px] px-[2px] cursor-pointer',
          { '!border-primary !bg-white dark:!bg-dark-8 ': isShowDropdown }
        )}
        onClick={toggleDropdown}
      >
        <div className='absolute left-[10px] top-[10px] w-[15px]'>
          <SearchIcon className='text-primary' height='20px' width='20px' />
        </div>
        <input
          className={cn(
            'text-[14px] text-secondary dark:text-dark-10 focus:text-primary font-light w-full truncate break-word h-[35px] pl-[30px] outline-none border-none rounded-[20px] bg-transparent'
          )}
          type='text'
          value={searchText}
          placeholder='ค้นหาด้วยนามปากกา'
          onChange={event => handleSearchChange(event.target.value)}
          onKeyDown={event => {
            if (event.key === 'Enter') {
              onSearch((event.target as HTMLInputElement).value)
            }
          }}
        />
      </div>
      <div
        className={cn(
          'cursor-pointer absolute w-full z-10 mt-[10px] py-[10px] right-0 bg-white dark:bg-dark-8 border border-gray dark:border-purple rounded-[10px] max-h-[400px] overflow-y-auto shadow text-[14px] text-secondary dark:text-dark-10 font-light',
          { hidden: !isShowDropdown || !penNameSearchList.length }
        )}
      >
        {penNameSearchList.map((row, index) => (
          <div
            className='hover:bg-primary-1 dark:hover:bg-dark hover:text-primary dark:hover:text-dark-10 py-[6px] px-[15px] space-x-[5px] flex'
            key={index}
            onClick={() => {
              toggleDropdown()
              handleSelectChange(row.label)
            }}
          >
            <div className='max-w-[140px] break-all truncate'>{row.label}</div>
            <div className='hover:text-secondary-1 text-secondary-1'>{`(${row.totalBook.toLocaleString()} งานเขียน)`}</div>
          </div>
        ))}
      </div>
    </div>
  )
}
